// removed by extract-text-webpack-plugin
module.exports = {"toggle":"_3eRtW","toggleVisible":"_1tTpi"};


/*****************
 ** WEBPACK FOOTER
 ** ./web_modules/MenuToggle/index.css
 ** module id = 466
 ** module chunks = 0
 **/